export default {
  questions: [
    { id: 'miesto', type: 'text', label: 'Location' },
    { id: 'popis', type: 'multiline', label: 'Problem description' },
  ],
}



// WEBPACK FOOTER //
// ./src/content/biznisnet2020/addons/feedback/reportProblem.js